import {map} from 'rxjs/operators';
import {toUiMsg$} from '@/ui';
import {spotActiveOrderData$} from './orders-active-spot';
import type {SpotActiveOrderData} from '@/types';

export interface UOrdersActiveSpot {
  type: 'spot-orders-active';
  data: SpotActiveOrderData;
}

export function subscribeSpotActiveOrder() {
  spotActiveOrderData$
    .pipe(map((orderData: SpotActiveOrderData): UOrdersActiveSpot => ({type: 'spot-orders-active', data: orderData})))
    .subscribe((msg) => toUiMsg$.next(msg));
}
